import React from 'react';
import { createRoot } from 'react-dom/client';
import ContentListing from './App';

const elementContainer = document.querySelector<HTMLElement>('#content-listing-root');

if (elementContainer) {
  const root = createRoot(elementContainer);
  root.render(<ContentListing />);
}
